import * as React from 'react';
import { exists, sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { fm } from 'Components/FormatMessage';
import EventStepper from '../../../../../../components/EventStepper';
import { defaultPapSettingsUnits } from '../../../config';
import { StepperHeaderValuePair } from '../../../../../../components/EventStepper/components';
import { mappedSettingFields } from '../config';

const ResMedSettings = ({ settings }: IOwnProps): React.JSX.Element => {
  const settingSorted = settings?.toSorted((a, b) => sortPartialDate(b.date, a.date));
  return (
    <EventStepper
      name="settings"
      formData={{ onChange: () => '', document: {} }}
      stepLabelText={(d: IPapSetting): string => formatPartialDate(d.date)}
      stepContent={(d: IPapSetting): React.JSX.Element => {
        return (
          <React.Fragment>
            {Object.values(mappedSettingFields).map((field, index) => {
              const value = d[field as keyof IPapSetting];
              return exists(value) ? (
                <StepperHeaderValuePair
                  key={`${field}${index}`}
                  header={fm(`treatment.papTherapy.${field}`)}
                  value={
                    field === 'epapAuto' ? (
                      fm(`treatment.papTherapy.opts.${value}`)
                    ) : (
                      <span>
                        {value}{' '}
                        {defaultPapSettingsUnits[field] === 'inhalationsPerMinute'
                          ? fm('treatment.papTherapy.inhalationsPerMinute')
                          : (defaultPapSettingsUnits[field] ?? '')}
                      </span>
                    )
                  }
                />
              ) : null;
            })}
          </React.Fragment>
        );
      }}
      addNewTextHeader="treatment.papTherapy.newSettings"
      addNewTextButton="treatment.papTherapy.newSettings"
      previousEventsTextHeader="treatment.papTherapy.settings"
      noPreviousEventsTextHeader="treatment.papTherapy.noSettings"
      editingElements={() => <></>}
      viewing={true}
      readOnlyEvents={settingSorted}
    />
  );
};

interface IOwnProps {
  settings?: Array<IPapSetting>;
}

export default ResMedSettings;
